import { render, staticRenderFns } from "./VentasView.vue?vue&type=template&id=5e94dc3f"
import script from "./VentasView.vue?vue&type=script&lang=js"
export * from "./VentasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports